<template>
  <div class="accesscontrol-banner">
    <img :src="accesscontrolBanner" alt="" />
    <div class="absolute">
      <div class="title">智能门禁</div>
      <div class="text">
        集微机自动识别技术和现代安全管理措施为一体新型现代化安全管理系统
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import accesscontrolBanner from '../../../../assets/programme/accesscontrolBanner.png'

export default {
  setup() {
    return reactive({
      accesscontrolBanner:accesscontrolBanner,
      experienceShow: false,
    })
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.accesscontrol-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .accesscontrol-banner {
    min-width: 1180px;
  }
}
.accesscontrol-banner img {
  width: 100%;
  height: 368px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 36%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 40px;
}
.absolute .title {
  font-size: 30px;
  color: #248EFB;
}
.absolute .text {
  width: 540px;
  font-size: 14px;
  margin-top: 20px;
  color: #248EFB;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #248EFB;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248EFB;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
